import ChangePasswordPage from './ChangePasswordPage';

export default ChangePasswordPage;


// WEBPACK FOOTER //
// ./src/components/pages/ChangePasswordPage/index.js